import { createContext, useContext, useEffect } from 'react';
import useAsync from '../hooks/async';
import { me } from '../api/services/user';

const AuthContext = createContext();
AuthContext.displayName = 'AuthContext';

export function AuthProvider({ children }) {
  const { data: user, run } = useAsync();

  useEffect(() => {
    run(me());
  }, [run]);

  const value = { user };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}
